import { FloatingButtonWrap, FloatingImg } from "src/styles/styledcomponent/views/join/FloatingButton"
import floating_button from 'src/assets/images/familycare_floating.png'

const FloatingButton = (props: any): JSX.Element=>{
    const { onMoveToElement} = props
    return (
        <FloatingButtonWrap>
            <FloatingImg 
                className="btn_floating_sms"
                src={floating_button}
                alt="floating_button"
                onClick={()=>onMoveToElement()}
            />
        </FloatingButtonWrap>
    )
}

export default FloatingButton